import { useContext } from "react";
import { ToastContext } from "./toastContext";
export default (function () {
    return useContext(ToastContext);
});
